import React from 'react'
import MuiTable from '../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_STOCK_EXPORTADOR } from '../../../config/tables'

function ComposicionStockExportadores () {
  return (
    <MuiTable id={TABLA_STOCK_EXPORTADOR} />
  )
}

export default ComposicionStockExportadores
